import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f7c1852"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "reaction-review"
};
const _hoisted_2 = {
  class: "review-options"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MappingLegend = _resolveComponent("MappingLegend");
  const _component_DigitSymbolShape = _resolveComponent("DigitSymbolShape");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", null, [_createElementVNode("span", null, "第 " + _toDisplayString($props.data.questionIndex + 1) + " 题", 1), _createElementVNode("strong", null, "目标数字 " + _toDisplayString($props.data.targetDigit), 1), _createElementVNode("span", null, _toDisplayString($props.review?.reactionTimeMs || 0) + " ms", 1)]), _createVNode(_component_MappingLegend, {
    mapping: $props.data.mapping || [],
    compact: ""
  }, null, 8, ["mapping"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.optionShapeIds, (shape, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: shape,
      class: _normalizeClass($options.optionClass(index))
    }, [_createVNode(_component_DigitSymbolShape, {
      "shape-id": shape,
      size: 64
    }, null, 8, ["shape-id"]), _createElementVNode("span", null, _toDisplayString(index + 1), 1)], 2);
  }), 128))]), _createElementVNode("p", null, _toDisplayString($options.resultText), 1)]);
}